import { useState } from 'react';
import { Button, Dialog, Textarea } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { useRembourserCommande, type CommandePresentee } from '../../api/boutique.js';
import { ErreurBoutique } from './commun.js';
import styles from './CommandeDetailPage.module.css';
export function RembourserDialog({
  galerie,
  commande,
  fermer,
}: {
  galerie: string;
  commande: CommandePresentee;
  fermer: () => void;
}) {
  const { t } = useTranslation('regie');
  const [motif, setMotif] = useState('');
  const mutation = useRembourserCommande(galerie);
  return (
    <Dialog
      open
      onOpenChange={(ouvert) => {
        if (!ouvert) fermer();
      }}
      title={t('boutique.rembourserTitre')}
      closeLabel={t('boutique.fermer')}
      description={t('boutique.rembourserAide', { numero: commande.facture?.numero ?? '—' })}
      footer={
        <>
          <Button variant="secondary" onClick={fermer}>
            {t('boutique.annuler')}
          </Button>
          <Button
            disabled={!motif.trim() || mutation.isPending}
            loading={mutation.isPending}
            onClick={() =>
              mutation.mutate({ id: commande.id, motif: motif.trim() }, { onSuccess: fermer })
            }
          >
            {t('boutique.confirmerRemboursement')}
          </Button>
        </>
      }
    >
      <label className={styles.champ}>
        <span>{t('boutique.motif')}</span>
        <Textarea
          value={motif}
          maxLength={500}
          rows={4}
          required
          disabled={mutation.isPending}
          onChange={(e) => setMotif(e.target.value)}
        />
      </label>
      {mutation.isError && <ErreurBoutique erreur={mutation.error} />}
    </Dialog>
  );
}
